import { render, staticRenderFns } from "./lookBigImgs.vue?vue&type=template&id=79f2603c&scoped=true&"
import script from "./lookBigImgs.vue?vue&type=script&lang=js&"
export * from "./lookBigImgs.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79f2603c",
  null
  
)

export default component.exports